import { useContext } from 'react';
import { CampaignEditorStateContext } from '../CampaignEditorStateProvider';

export const useCampaignEditorContext = () => {
  const context = useContext(CampaignEditorStateContext);

  if (!context) {
    throw new Error('useCampaignEditorContext must be wrapped in a CampaignEditorStateProvider.');
  }

  return context;
};
